<template>
  <div class="full-width full-height d-flex justify-center align-center">
    <loading-component></loading-component>
  </div>
</template>

<script>
export default {
  props: {},
  data: () => ({}),
  computed: {},
  methods: {}
};
</script>

<style scoped></style>
